<template>
    <div class="form-box">
        <!-- <div class="form-left">
            <p v-for="(item,index) in dataTree" :key="index" :class="(curId==index?'on':'')" @click="handleNodeClick(item,index)" style="width:100%;height:4vh;position: relative;display: flex;align-content: center;align-items: center;padding-left: 1vh;cursor: pointer;">
                {{item.name}}
            </p>
        </div> -->
        <div class="form-right">
            <div style="width:100%;height:5vh;padding-left:1vw;background:#fff;display:flex;align-items: center;">
                <el-page-header @back="goBack" :content="params.name"></el-page-header>
            </div>
            <!-- <div style="width:100%;height:5vh;padding-left:1vw;background:#fff;display:flex;align-items: center;">
            <div style="width:20%;text-align:left;color:#f00">合计:</div>
                <ul class="ul-s">
                    <li class="li-16" style="width:12%;">合同价:{{entity.contractPrice}}</li>
                    <li class="li-16" style="width:15%;">累计审定产值:{{entity.judgementValue}}</li>
                    <li class="li-16" style="width:18%;">累计工程款支付:{{entity.actualPayment}}</li>
                    <li class="li-16" style="width:20%;">累计农民工专户支付:{{entity.specialAccount}}</li>
                    <li class="li-16" style="width:20%;">农民工专户支付比例:{{entity.specialAccountRatio}}</li>
                    <li class="li-16" style="width:12%;">违约金:{{entity.fine}}</li>
                </ul>
            </div> -->
            <div style="width:100%;height:calc( 100% - 5vh );position: relative;padding:1vh;background:#fff;">
                <el-table :data="tableData" border style="width: 100%" height="100%" :header-row-class-name="'table-head'">
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column prop="index" label="汇总">
                        <el-table-column prop="index" label="序号" width="100">
                            <template slot-scope="scope">
                                <span>{{scope.row.index}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="contractName" label="项目合同名称">
                            <template slot-scope="scope">
                                <span @click="toTable(scope.row)" class="colorstyle">{{scope.row.contractName}}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="entity.contractPrice">
                        <el-table-column prop="contractPrice" label="合同价">
                            <template slot-scope="scope">
                                <span>{{scope.row.contractPrice}}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="entity.judgementValue">
                        <el-table-column prop="status" label="累计审定产值">
                            <template slot-scope="scope">
                                <p>{{scope.row.first.total0}}</p>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="entity.actualPayment">
                        <el-table-column prop="num" label="累计工程款支付">
                            <template slot-scope="scope">
                                <span >{{scope.row.first.total2}}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="entity.specialAccount">
                        <el-table-column prop="num" label="累计农民工专户支付">
                            <template slot-scope="scope">
                                <span v-if="scope.row.unitKind=='2'">--</span>
                                <span v-else>{{scope.row.first.total3}}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="entity.specialAccountRatio">
                        <el-table-column prop="num" label="农民工专户支付比例">
                            <template slot-scope="scope">
                                <span v-if="scope.row.unitKind=='2'">--</span>
                                <span v-else>{{scope.row.first.bilv}}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="entity.fine">
                        <el-table-column prop="num" label="违约金">
                            <template slot-scope="scope">
                                <span >{{scope.row.first.total4}}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    
                    <!-- <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="success" @click="infoFun(scope.row)">查看</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>

            </div>
        </div>
    </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
    data(){
        return{
            groupId:'',
            dataTree:[],
            defaultProps: {
                children: 'list',
                label: 'name'
            },
            projectId:'',//当前项目id
            currentNodekey:'',//当前树形选中值
            expandedkeys:[],//树形展开值
            dataText: '数据加载中...',
            tableData:[],
            curId:0,
            currentPage: 1,
            pageSize: 10,
            totalItems: 0,
            params:{},
            entity:{
                actualPayment: 0,
                contractPrice: 0,
                fine: 0,
                judgementValue: 0,
                specialAccount: 0,
                specialAccountRatio: 0,

            }
        }
    },
    mounted(){
        console.log(this.$route.params)
        var params = this.$route.params
        this.params = params
        this.groupId = util.session.get('groupId')
        this.getLeftMenu()
        this.getToltal()
    },
    methods:{
        //获取侧边树
        getLeftMenu(){
            var that = this
            myHttp.getEntProjectList({
                groupId: this.groupId,
                pageNum:1,
                pageSize:10000
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.entProject.list || []
                    that.dataTree = list
                    if (list.length > 0 && that.projectId=='') {
                        that.projectId= list[0].id
                        that.getData()
                    }
                }
            })
        },
        //树形点击
        handleNodeClick(e,index){
            this.projectId = e.id
            this.curId = index
            this.getData()
        
        },
        //获取数据
        getData(){
              var that = this
            myHttp.selectAllPayListByEntProjectId({
                entId:this.groupId,
                entProjectName:this.proName,
                contractName:this.contractName,
                pageNum:this.currentPage,
                pageSize:this.pageSize,
                entProjectId:this.params.id
            }).then(function(resp){
                console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data.list.list||[]
                    for(var i=0;i<list.length;i++){
                        list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                        list[i].first = list[i].first?JSON.parse(list[i].first):{list:0,total:0,total2:0,total3:0,total4:0}
                        list[i].first.total2 = list[i].first.total2?list[i].first.total2:0 
                        list[i].first.total4 = list[i].first.total4?list[i].first.total4:0 
                        list[i].first.total3 = list[i].first.total3?list[i].first.total3:0 
                        list[i].firstAll = list[i].first.total2 + list[i].first.total4
                        list[i].first.bilv =list[i].first.total2==0&&list[i].first.total4==0?0:(parseFloat(list[i].first.total3)/parseFloat(list[i].firstAll)*100).toFixed(2)+'%'
                    }
                    that.tableData = list
                    if(list.length==0){
                        that.dataText = '暂无数据'
                    }
                    that.totalItems = resp.data.data.list.total
                }else{
                     that.dataText = '暂无数据'
                }
            })
        },
            /**统计汇总 */ 
            getToltal(){
            var that = this
            myHttp.selectTotalPayCount({
                entId:this.groupId,
                entProjectId:this.params.id,
                // contractName:this.contractName,
            }).then(function(resp){
                console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data.entity
                    that.entity =list
                }else{
                     that.dataText = '暂无数据'
                }
            })
        },
        //返回
        goBack(){
            this.$router.go(-1)
        },
        // toTable
        toTable(row){
          console.log(row)
           this.$router.push({path:'/form1/'+row.contractId+'/'+row.contractName+'/'+this.params.name,})
        }
    }
}
</script>

<style scoped>
    .form-box{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        padding: 1vh;
    }
    .form-left{
        width:15vw;
        height: 100%;
        position: relative;
        background: #fff;
        padding: 1vh;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        align-items: flex-start;
    }
    .form-left .on{
        color: #2447D7;
    }
    .form-right{
        width: 100%;
        height: 100%;
        position: relative;
        padding-left: 1vh;
    }
     .colorstyle{
        color: rgb(85, 122, 170);
        cursor: pointer;
    }
    .colorstyle:hover{
        color: #40aaff
    }
    .ul-s{
        width: 80%;
        display: flex;
        text-align: left;
        justify-content: space-between
    }
    .li-16{
        width: 16.7%
    }
</style>

<style>
    @import '../../../assets/css/common.css';
    .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
</style>